import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { useState, useEffect } from 'react';
import { FaEdit } from 'react-icons/fa';
import { MdDelete } from 'react-icons/md';
import { IoSearchOutline } from 'react-icons/io5';
import { Button, Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { PiWarningCircleBold } from 'react-icons/pi';
// Custom components
import * as React from 'react';
import { IoMdAdd } from 'react-icons/io';
import { useDispatch, useSelector } from 'react-redux';
import {
  addMedical,
  deleteDoctor,
  deleteMedicial,
  getMedical,
  searchMedicial,
  updateMedicial,
} from '../../../redux/actions/Master.action';
import ReactPaginate from 'react-paginate';
import { Formik, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';

export default function MedicalList() {
  const [show, setShow] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [medicineId, setMedicineId] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [searchDefault, setSearchDefault] = useState({
    page: '',
    search: '',
  });

  const initialValues = {
    medicinename: '',
    dose: '',
    qty: '',
  };

  const validationSchema = Yup.object().shape({
    medicinename: Yup.string().required('Medicine Name is required'),
    dose: Yup.string().required('Dose is required'),
    qty: Yup.string().required('Qty is required'),
  });

  const toggle = () => { setShow(!show); };
  const updateToggle = () => { setUpdateModal(!updateModal); };
  const deleteToggle = () => { setDeleteModal(!deleteModal); };

  const dispatch = useDispatch();
  const getFile = useSelector((state) => state.master);

  const [mainPage, setMainPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [formData, setFormData] = useState({
    medicinename: '',
    dose: '',
    qty: '',
  });

  const limits = {
    page: mainPage,
    limit: rowsPerPage,
  };

  const handleAddDoctor = (values, { resetForm }) => {
    dispatch(addMedical(values, limits)).then(() => {
      toggle();
      resetForm();
    });
  };

  const handleDeleteDoctor = () => {
    dispatch(deleteMedicial(medicineId, limits)).then(() => {
      deleteToggle();
      setMainPage(1);
    });
  };

  const handleUpdateDoctor = (values) => {
    const payload = {
      medicineId: medicineId,
      medicinename: values.medicinename,
      dose: values.dose,
      qty: values.qty,
    };
    dispatch(updateMedicial(payload, limits)).then(() => {
      setUpdateModal(false);
    });
  };

  const handleSearch = (e) => {
    const newSearchQuery = e.target.value;
    setSearchQuery(newSearchQuery);
    const newSearchParams = {
      ...searchDefault,
      search: newSearchQuery || '',
      page: mainPage,
    };
    setSearchDefault(newSearchParams);
    const queryParams = new URLSearchParams(newSearchParams).toString();
    dispatch(searchMedicial(queryParams, newSearchParams.page));
  };

  // const ChangeMainPage = (selected) => {
  //   setMainPage(parseInt(selected.selected) + 1);
  // };

  const ChangeMainPage = (selected) => {
    setMainPage(parseInt(selected.selected) + 1);
    const updatedSearchParams = {
      ...searchDefault,
      search: searchQuery,
      page: parseInt(selected.selected) + 1,
    };
    setSearchDefault(updatedSearchParams);
    const queryParams = new URLSearchParams(updatedSearchParams).toString();
    dispatch(searchMedicial(queryParams, updatedSearchParams.page));
  };


  const handleRowsPerPageChange = (e) => {
    const newRowsPerPage = parseInt(e.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setMainPage(1);
  };

  const postPerPage = rowsPerPage;
  const PageCount = Math.ceil(
    getFile?.getMedical?.data?.totalCount / postPerPage,
  );

  useEffect(() => {
    if (searchQuery) {
      const updatedSearchParams = { ...searchDefault, search: searchQuery, page: mainPage };
      const queryParams = new URLSearchParams(updatedSearchParams).toString();
      dispatch(searchMedicial(queryParams, updatedSearchParams.page));
    } else {
      dispatch(getMedical(limits));
    }
  }, [mainPage, rowsPerPage, searchQuery]);


  return (
    <>
      <div className="mt-[100px] d-flex justify-content-end">
        <div className="d-flex items-center gap-3">
          <div className="bg-white shadow-shadows py-[8px] px-[20px] rounded-full flex items-center gap-2">
            <IoSearchOutline />
            <input
              type="text"
              name="search"
              value={searchQuery}
              onChange={handleSearch}
              className="w-full outline-none"
              placeholder="Search..."
            />
          </div>
          <div>
            <Button
              onClick={toggle}
              className="!bg-theme-dark fw-bold d-flex align-item-center border-0"
            >
              <IoMdAdd className="mt-1 gap-1" />
              Add Medicine
            </Button>
          </div>
        </div>
      </div>
      <div className="mt-[50px] mb-4">
        <div className='mb-3 flex items-center justify-between mt-5'>
          <h3 className='fw-bold'>Medicine List</h3>
          <div className='ms-auto border-r pe-3 me-3'>Total Records: <span className='text-success border-b border-success'>{getFile?.getMedical?.data?.totalCount || 0}</span></div>

          <div>
            Rows per page:
            <select
              value={rowsPerPage}
              onChange={handleRowsPerPageChange}
              className="ms-2 border rounded-md focus:outline-none"
            >
              <option value={10}>10</option>
              <option value={30}>30</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={500}>500</option>
            </select>
          </div>
        </div>
        <TableContainer>
          <Table variant="striped" colorScheme="blackAlpha">
            <Thead>
              <Tr>
                <Th>Medicine Name</Th>
                <Th>Dose</Th>
                <Th>Qty</Th>
                <Th>Days</Th>
                <Th>Action</Th>
              </Tr>
            </Thead>
            <Tbody>
              {getFile?.getMedical?.data?.medicine?.length > 0 ? (
                getFile?.getMedical?.data?.medicine?.map((res) => {
                  return (
                    <Tr key={res._id}>
                      <Td>{res.medicinename}</Td>
                      <Td>{res.dose}</Td>
                      <Td>{res.qty}</Td>
                      <Td>10</Td>
                      <Td style={{ minWidth: '200px' }}>
                        <div className="d-flex gap-3 ">
                          <FaEdit
                            onClick={() => {
                              updateToggle();
                              setMedicineId(res._id);
                              setFormData(res);
                            }}
                            className="cursor-pointer border-green-color fs-5 text-success"
                            title="update"
                          />
                          <MdDelete
                            onClick={() => {
                              deleteToggle();
                              setMedicineId(res._id);
                            }}
                            className="cursor-pointer border-green-color fs-5 text-danger"
                            title="delete"
                          />
                        </div>
                      </Td>
                    </Tr>
                  );
                })
              ) : (
                <>
                  <Tr>
                    <Td colSpan={5} textAlign="center">
                      Medicine Not Found
                    </Td>
                  </Tr>
                </>
              )}
            </Tbody>
          </Table>
        </TableContainer>
      </div>

      <ReactPaginate
        breakLabel="..."
        nextLabel="next >"
        onPageChange={ChangeMainPage}
        pageRangeDisplayed={1}
        pageCount={PageCount}
        previousLabel="< previous"
        renderOnZeroPageCount={null}
        className="pagination"
      />

      {/* add doctor */}
      <Modal show={show} onHide={toggle}>
        <Modal.Header closeButton>
          <Modal.Title>Add Medicine</Modal.Title>
        </Modal.Header>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleAddDoctor}
        >
          {({ handleSubmit, setFieldValue, values }) => (
            <Form onSubmit={handleSubmit}>
              <Modal.Body>
                <div className="row">
                  <div className="col-12">
                    <Form.Group className="mb-3">
                      <Form.Label>Medicine Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="medicinename"
                        as={Form.Control}
                        onChange={(e) =>
                          setFieldValue('medicinename', e.target.value)
                        }
                        value={values.medicinename}
                        placeholder="Enter Medicine Name"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="medicinename"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-12">
                    <Form.Group className="mb-3">
                      <Form.Label>Dose</Form.Label>
                      <Form.Control
                        type="text"
                        name="dose"
                        as={Form.Control}
                        onChange={(e) =>
                          setFieldValue('dose', e.target.value)
                        }
                        value={values.dose}
                        placeholder="Enter Dose"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="dose"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-12">
                    <Form.Group className="mb-3">
                      <Form.Label>Qty</Form.Label>
                      <Form.Control
                        type="text"
                        name="qty"
                        as={Form.Control}
                        onChange={(e) =>
                          setFieldValue('qty', e.target.value)}
                        value={values.qty}
                        placeholder="Enter Qty"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="qty"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={toggle}
                  className="px-4 bg-transparent border-[1px] text-black border-green-color"
                >
                  Close
                </Button>
                <Button
                  type="submit"
                  className="!bg-theme-dark border-0 px-4"
                // onClick={handleAddDoctor}
                >
                  Add
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>

      {/* update doctor */}

      <Modal show={updateModal} onHide={updateToggle}>
        <Modal.Header closeButton>
          <Modal.Title>Update Medicine</Modal.Title>
        </Modal.Header>
        <Formik
          enableReinitialize={true}
          initialValues={formData}
          validationSchema={validationSchema}
          onSubmit={handleUpdateDoctor}
        >
          {({ handleSubmit, setFieldValue, values }) => (
            <Form onSubmit={handleSubmit}>
              <Modal.Body>
                <div className="row">
                  <div className="col-12">
                    <Form.Group className="mb-3">
                      <Form.Label>Medicine Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="medicinename"
                        as={Form.Control}
                        onChange={(e) =>
                          setFieldValue('medicinename', e.target.value)
                        }
                        value={values.medicinename}
                        placeholder="Enter Medicine Name"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="medicinename"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-12">
                    <Form.Group className="mb-3">
                      <Form.Label>Dose</Form.Label>
                      <Form.Control
                        type="text"
                        name="dose"
                        as={Form.Control}
                        onChange={(e) =>
                          setFieldValue('dose', e.target.value)
                        }
                        value={values.dose}
                        placeholder="Enter Dose"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="dose"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-12">
                    <Form.Group className="mb-3">
                      <Form.Label>Qty</Form.Label>
                      <Form.Control
                        type="text"
                        name="qty"
                        as={Form.Control}
                        onChange={(e) =>
                          setFieldValue('qty', e.target.value)
                        }
                        value={values.qty}
                        placeholder="Enter Qty"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="qty"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                </div>
              </Modal.Body>

              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={updateToggle}
                  className="px-4 bg-transparent border-[1px] text-black border-green-color"
                >
                  Close
                </Button>
                <Button
                  type="submit"
                  className="!bg-green-color border-0 px-4"
                // onClick={handleUpdateDoctor}
                >
                  Update
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>

      {/* delete doctor */}

      <Modal show={deleteModal} onHide={deleteToggle}>
        <Modal.Body className="p-5">
          <div>
            <PiWarningCircleBold className="text-7xl w-100 text-danger" />
          </div>
          <div className="text-center mt-4">
            <h3>Are You Sure ?</h3>
            <p className="text-md">
              Do you really want to delete these records?
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={deleteToggle}
            className="px-4 bg-transparent border-[1px] text-black border-green-color"
          >
            No
          </Button>
          <Button
            type="submit"
            className="bg-danger border-0 px-4"
            onClick={handleDeleteDoctor}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
